import React from 'react';

interface TableContainerProps {
  children: React.ReactNode;
  className?: string;
}

const TableContainer: React.FC<TableContainerProps> = ({ children, className = '' }) => {
  return (
    <div className="relative">
      {/* Fade indicator on the right for mobile to show more content */}
      <div className="sm:hidden absolute top-0 right-0 bottom-0 w-12 bg-gradient-to-l from-bg-secondary to-transparent pointer-events-none z-10 rounded-r-lg" />
      <div className={`overflow-x-auto rounded-lg border border-border-primary bg-bg-secondary ${className}`}>
        {children}
      </div>
    </div>
  );
};

export default TableContainer;